import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import module from 'app/modules/well-healthiness/well-healthiness.module';
import { WellHealthinessService } from '../../services/well-healthiness.service';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { CMStatus } from 'app/modules/corrective-maintenance/model/corrective-maintenance.model';

@Component({
  selector: 'app-view-cm',
  standalone: true,
  imports: module,
  templateUrl: './view-cm.component.html',
  styleUrl: './view-cm.component.scss'
})

export class ViewCmComponent {
  isUpdate: boolean = false;
  status = CMStatus;

  dtCmBaseline: any[] = []
  dtCmEmerging: any[] = []
  dtGeneral:  any[] = []

  constructor(
      public dialogRef: MatDialogRef<ViewCmComponent>,
      @Inject(MAT_DIALOG_DATA)
      public data: any,
      public service: WellHealthinessService,
  ) {}

  ngOnInit(){
    this.getCmRecords()
  }

  getCmRecords(){
    const params = { wellStringId : this.data.wellStringId }

    this.service.getOpenCMRecords(params).subscribe((res)=> {
      const cmRecords = res.data

      this.dtCmBaseline = cmRecords.filter(x => x.category == 'Baseline')
      this.dtCmEmerging = cmRecords.filter(x => x.category == 'Emerging')
      this.dtGeneral = cmRecords.filter(x => x.category == 'General')
    })
  }

  handleFormatDate(dateString: any, withTime: boolean) {
    return handleFormatDate(dateString, withTime)
  }

}
